// extracted by css-extract-rspack-plugin
export default {"root":"MaskTab_root__um7V3","selected":"MaskTab_selected__WmmQC","error":"MaskTab_error__3pmqu","badge":"MaskTab_badge__OUbR0","tabWrapper":"MaskTab_tabWrapper__N9lDd"};